import type { JobStatus } from '@uroute/shared';
import { isDelivered } from '../lib/jobStatus';
import { AlertTriangle, Check } from './icons';

const FLOW: JobStatus[] = ['allocated', 'accepted', 'in_progress', 'completed'];

const STEP_LABEL: Record<string, string> = {
  allocated: 'Allocated',
  accepted: 'Accepted',
  in_progress: 'In Progress',
  completed: 'Delivered',
};

/** Status progress stepper — mirrors the shared state machine visually. */
export function StatusStepper({ status }: { status: JobStatus }) {
  const delivered = isDelivered(status);
  const idx = FLOW.indexOf(status);
  const current = delivered ? FLOW.length : idx >= 0 ? idx : FLOW.indexOf('in_progress');

  return (
    <div data-testid="status-stepper">
      <ol className="stepper">
        {FLOW.map((step, i) => {
          const state = i < current ? 'done' : i === current ? 'active' : 'todo';
          return (
            <li
              key={step}
              className={`stepper__step stepper__step--${state}`}
              data-state={state}
              data-step={step}
              aria-current={state === 'active' ? 'step' : undefined}
            >
              <span className="stepper__dot">
                {state === 'done' ? <Check size={12} strokeWidth={2.5} /> : i + 1}
              </span>
              <span className="stepper__label">{STEP_LABEL[step]}</span>
            </li>
          );
        })}
      </ol>
      {status === 'exception' ? (
        <p className="stepper__exception" data-testid="stepper-exception">
          <AlertTriangle size={16} />
          <span>
            Flagged as an <strong>exception</strong> — dispatch has been notified. Resume the
            delivery once it&rsquo;s resolved.
          </span>
        </p>
      ) : null}
      {delivered ? (
        <p className="stepper__done" data-testid="stepper-done">
          <Check size={16} />
          <span>Delivered — this job is complete.</span>
        </p>
      ) : null}
    </div>
  );
}
